import styled from 'styled-components';
import {ByocOnboardingContainer} from '../styles';

export const MenuSetupContainer = styled(ByocOnboardingContainer)`
  position: relative;
`;

export const MenuSourceField = styled.div`
  margin-top: 24px;
  width: 100%;
  max-width: 400px;
`;

export const MenuSetupButton = styled.div`
  margin-top: 16px;
  width: 100%;
  max-width: 200px;
`;
